var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHaidiPatientListIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#haidiPatientListIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 1.5h-1.5v9H12v-9ZM8.25 0H.75A.75.75 0 0 0 0 .75v10.5a.75.75 0 0 0 .75.75h7.5a.75.75 0 0 0 .75-.75V.75A.75.75 0 0 0 8.25 0ZM4.5 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm2.25 6h-4.5V7.5h4.5V9Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "haidiPatientListIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h12v12H0z"
})))));
export default SvgHaidiPatientListIcon;